import { css } from '@emotion/css';
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
} from '@material-ui/core';
/* eslint-disable no-nested-ternary */
import Grid from '@material-ui/core/Grid';
import { makeStyles } from '@material-ui/core/styles';
import { Skeleton } from '@material-ui/lab';
import {
  getBusinessesSectors,
  getContractTypes,
  getDegreeLevels,
  getOffresMap,
  searchSchoolsPartners
} from '@webapps/business';
import {
  FormikAutocompletePx,
  PaginationNumbers,
  TextField,
  useAuth,
  useQuery,
  useRouter,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import { useEffect, useMemo, useState } from 'react';
import { FormattedMessage } from 'react-intl';

import CardOffer from './CardOffer';

const Offers = ({ id }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const [idSector, setIdSector] = useState('');
  const [degreeLevel, setDegreeLevel] = useState('');
  const [contractType, setContractType] = useState('');
  const [contractLength, setContractLength] = useState(0);

  const { idUser, profile } = useAuth();

  const { params } = useRouter();

  const { id: idParam } = params;

  const [page, setPage] = useState(1);
  const [size, setSize] = useState(window.innerWidth < 768 ? 3 : 4);

  const { data: { content: partnersSchool = [] } = {} } = useQuery(searchSchoolsPartners, {
    key: ['schoolsPartnersRequestOffers', page, idParam || idUser],
    variables: {
      id: typeof idParam !== 'undefined' ? idParam : idUser,
      individual: profile === 'INDIVIDUAL' ? idUser : undefined,
      accept: true,
      page: 0,
      size: 1000,
    },
    keepPreviousData: true,
    staleTime: 5000,
  });

  const {
    status: load,
    data: { content: offres = [], totalElements } = {},
    refetch,
    isFetching,
  } = useQuery(getOffresMap, {
    key: [
      'offers',
      idParam || idUser +
      page,
    ],
    variables: {
      businesses: partnersSchool?.filter(({ status }) => status === undefined).map(({ id: idPartner }) => idPartner).join(),
      businessesExternals: partnersSchool?.filter(({ status }) => status !== undefined).map(({ id: idPartner }) => idPartner).join(),
      contracts: contractType,
      contractLengths: contractLength,
      degreeLevels: degreeLevel,
      sectors: idSector,
      accountId: idUser,
      page: page - 1,
      size,
      status: 'opened',
    },
    keepPreviousData: true,
    enabled: partnersSchool.length > 0,
  });

  const { data: sectors = [] } = useQuery(
    getBusinessesSectors,
    {
      key: 'allSectorsJobs',
    }
  );

  const { data: degreeLevels = [] } = useQuery(
    getDegreeLevels,
    {
      key: 'levels',
    }
  );

  const { data: contractTypes = [] } = useQuery(
    getContractTypes,
    {
      key: 'contractTypes',
    }
  );

  const searchIdSectors = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setIdSector(newValue);
    setPage(1);
  };

  const searchDegreeLevels = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setDegreeLevel(newValue);
    setPage(1);
  };

  const searchContractTypes = (e) => {
    const newValue = e.target.value === 'all' ? '' : e.target.value;
    setContractType(newValue);
    setPage(1);
  };

  const searchContractLength = (e) => {
    const newValue =
      e.target.value === 'all' ? 0 : parseInt(e.target.value, 10);
    setContractLength(newValue);
    setPage(1);
  };

  const [scroll, setScroll] = useState(false);

  const handleScroll = (e) => {
    if (scroll) return;
    const { scrollHeight, scrollTop, clientHeight } = e.target;
    const scrollPercentage = (scrollTop / (scrollHeight - clientHeight)) * 100;
    if (scrollPercentage >= 80) {
      setScroll(true);
    }
  };

  useEffect(() => {
    if (scroll) {
      if (totalElements <= size) {
        return;
      }
      setSize(size + 4);
      setTimeout(() => {
        setScroll(false);
        refetch();
      }, 200);
    }
  }
    , [scroll]);

  useEffect(() => {
    if (partnersSchool.length) {
      refetch();
    }
  }, [idSector, degreeLevel, contractType, contractLength]);

  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}>
        Les offres de nos partenaires
      </div>
      <div className={classes.formations}>
        <div className={classes.offersDiv}>
          <Grid
            container
            className={css({
              '@media (max-width:768px)': {
                flexDirection: 'column',
              },
            })}
            spacing={1}
          >
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Niveau de diplôme"
                name="degreeLevels"
                placeholder="Tous"
                onChange={(e) => searchDegreeLevels(e)}
                select
                borderRadius={400}
              >
                <MenuItem value="all">Tous</MenuItem>
                {degreeLevels.map(({ id: idDeg, label }, index) => (
                  <MenuItem
                    key={index}
                    value={idDeg}
                    className={css({ color: '#152652 !important' })}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                borderRadius={400}
                fullWidth
                label="Domaines professionnels"
                name="idSector"
                placeholder="Tous"
                onChange={(e) => searchIdSectors(e)}
                select
              >
                <MenuItem value="all" className={classes.menuItem}>
                  Tous
                </MenuItem>
                {sectors.map(({ id: idSec, label }, index) => (
                  <MenuItem
                    key={index}
                    value={idSec}
                    className={css({ color: '#152652 !important' })}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                fullWidth
                label="Type de contrat"
                name="contractType"
                onChange={(e) => searchContractTypes(e)}
                select
                value={contractTypes?.label}
                borderRadius={400}
              >
                <MenuItem value="all">Tous</MenuItem>
                {contractTypes.map(({ id: idContract, label }, index) => (
                  <MenuItem
                    key={index}
                    value={idContract}
                    className={css({ color: '#152652 !important' })}
                  >
                    {label}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
            <Grid item xs={12} md={3}>
              <TextField
                borderRadius={400}
                fullWidth
                label="Durée du contrat"
                name="contractLength"
                onChange={(e) => searchContractLength(e)}
                select
                value={sectors?.label}
              >
                <MenuItem value="all">Durée (en mois)</MenuItem>
                {Array.from({ length: 36 }, (_, index) => (
                  <MenuItem key={index} value={index + 1}>
                    {index + 1}
                  </MenuItem>
                ))}
              </TextField>
            </Grid>
          </Grid>
        </div>
      </div>
      {!offres?.length ? (
        <div
          className={css({
            textAlign: 'center',
            color: '#5D75A8',
            padding: '20px',
          })}
        >
          <FormattedMessage id="noElements" />
        </div>
      ) : (
        <Grid
          container
          direction="column"
          className={css({
            backgroundColor: '#F3F7FF',
            marginTop: spacing(2),
            padding: spacing(2),
            borderRadius: 10,
            maxHeight: '204px',
            '@media only screen and (max-width: 768px)': {
              height: 'auto',
              overflowX: 'hidden',
              maxHeight: 'none',
            },
          })}
        >
          <div
            className={css({
              flexDirection: 'row',
              display: 'flex',
              gap: 16,
              paddingRight: offres?.length > 2 ? spacing(2) : 0,
              overflowX: 'hidden',
              flexWrap: 'wrap',
              '&::-webkit-scrollbar': {
                backgroundColor: '#F3F7FF',
              },
              '&::-webkit-scrollbar-thumb': {
                backgroundColor: '#0060F9',
              },
              '&::-webkit-scrollbar-track': {
                backgroundColor: '#C0D9FF',
              },
              '@media only screen and (max-width: 768px)': { overflow: 'hidden', padding: 0 },
            })}
            onScroll={(e) => handleScroll(e)}
          >
            {offres?.map((item, index) => (
              <CardOffer
                key={index}
                address={item?.address}
                contrat={item?.contractType}
                item={item}
                lastTimeView={item?.createdAt}
                name={item?.job}
                typeFormation={item?.degreeLevel}
              />
            ))}
          </div>
        </Grid>
      )}
      <div className={classes.pagination}>
        <PaginationNumbers
          onChange={(newPage) => setPage(newPage)}
          page={page}
          pageCount={size}
          totalCount={totalElements}
        />
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    backgroundColor: 'white',
    borderRadius: 10,
    padding: spacing(2.5),
    '@media screen and (max-width: 768px)': {
      marginBottom: 20,
    },
  },
  pagination: {
    '@media screen and (min-width: 768px)': {
      display: 'none',
    }
  },
  title: {
    borderLeft: '3px solid #0060F9',
    paddingLeft: 8,
    marginBottom: spacing(2),
    width: '100%',
  },
  offersDiv: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
  },
  formations: {
    display: 'flex',
    width: '100%',
  },
});

export default Offers;
